import { render } from "./WordQueryResultsWidget.vue?vue&type=template&id=c02b58f2&scoped=true"
import script from "./WordQueryResultsWidget.vue?vue&type=script&lang=js"
export * from "./WordQueryResultsWidget.vue?vue&type=script&lang=js"

import "./WordQueryResultsWidget.vue?vue&type=style&index=0&id=c02b58f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02b58f2"]])

export default __exports__